:host {
  display: block;
  max-width: 100%;
  padding: 0 calc(var(--spacer) * 2);
  overflow: hidden;
}

gz-accordion {
  &::part(accordionContainer) {
    margin: 0;
  }
}

.accordion-count {
  flex: 0;
}

.accordion-title {
  width: auto;
}

.accordion-item,
.accordion-count {
  padding-left: calc(var(--spacer) / 2);
}

.panel-content {
  flex: 2;
  overflow: auto;
  height: calc(100% - 124px);
}

.accordion-title {
  text-transform: uppercase;
  font-size: var(--body-size-small);
  font-weight: 500;
}

.accordion-title,
.accordion-count {
  color: var(--chart-300-icon-buttons);
}

.label-text {
  color: var(--chart-300-icon-buttons);
}

gz-icon-label::part(label) {
  padding: 0;
}
